export default __webpack_public_path__ + "static/media/Fulfillment-06.e06f4557.svg";